<template>
  <div
    v-if="active"
    class="m-combo-market-item"
  >
    <div
      class="m-market-item--header"
      :class="{
        isFold: !shouldExpand
      }"
    >
      <h1 class="m-market-item--name tw-flex tw-items-center">
        <a
          class="tw-line-clamp-2"
          @click="handleExpand"
        >
          <span class="m-control-btn m-collapse-btn">
            <i
              class="m-icon-trangle down"
              :class="{
                active: !shouldExpand
              }"
            />
          </span>
          <span>{{ getComboMarketTitle(marketInfo) }}</span>
        </a>
      </h1>
    </div>

    <div
      v-show="shouldExpand"
      ref="marketContent"
      class="m-market-item--content"
    >
      <Market1Specifier
        v-if="marketInfo.comboType === 1 && hasOutcomes(marketInfo)"
        :markets="comboMarketGroups.map[id]"
        :event="event"
      />
      <ComboMarket2
        v-else-if="marketInfo.comboType === 2"
        :group="group"
      />
      <ComboMarket4
        v-else-if="marketInfo.comboType === 4"
        :group="group"
      />
      <ComboMarket3And5
        v-else-if="marketInfo.comboType === 3 || marketInfo.comboType === 5"
        :group="group"
      />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useWapBetslipStore } from 'wap/stores/betslip'
import { useDetailStore } from '@ms/stores/matchDetail'
import { getComboMarketTitle } from '@ms/components/matchDetail/market.js'
import eventBus from '@ms/utils/event-bus.js'
import Market1Specifier from '../components/Market1Specifier'
import ComboMarket2 from '../components/ComboMarket2.vue'
import ComboMarket4 from '../components/ComboMarket4.vue'
import ComboMarket3And5 from '../components/ComboMarket3And5.vue'

export default {
  name: 'MarketComboItem',
  components: {
    Market1Specifier,
    ComboMarket2,
    ComboMarket4,
    ComboMarket3And5
  },
  props: {
    market: {
      type: [Object, Array],
      default: () => ({})
    },
    marketId: {
      type: [Number, String],
      default: ''
    },
    group: {
      type: [Object, Array],
      default: () => ({})
    },
    shouldExpand: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const marketContent = ref(null)

    const matchDetailStore = useMatchDetailStore()
    const { event } = storeToRefs(matchDetailStore)

    const { toggleFavouriteMarket, fetchMarketInfo, subBlacklist } = matchDetailStore

    const { selectionList } = storeToRefs(useWapBetslipStore())

    const { comboMarketGroups } = storeToRefs(useDetailStore())

    return {
      getComboMarketTitle,
      marketContent,
      event,
      toggleFavouriteMarket,
      fetchMarketInfo,
      subBlacklist,
      selectionList,
      comboMarketGroups
    }
  },
  data() {
    return {
      id: '',
      normalIds: [],
      // visible: true,
      marketInfo: {},
      isSpecifiers: false,
      widgetVisible: false,
      loading: false,
      hasFetched: false,
      active: false
    }
  },
  computed: {
    types() {
      const { comboType, comboGroupName, marketGroups } = this.group
      if (comboType === 1) {
        return [`${comboType}_${comboGroupName}`]
      }

      const ids = marketGroups.map((x) => {
        if (!x.markets.length) {
          return ''
        }
        const id = x.markets[0].id
        return `${comboType}_${comboGroupName}_${id}`
      })

      return ids.filter((x) => x)
    },
    checkIsActive() {
      const val = 0
      const vals = []
      if (!this.types.length) return val

      this.types.forEach((x) => {
        const markets = this.comboMarketGroups.map[x]

        if (Array.isArray(markets)) {
          if (markets.every((x) => +x.status === 2)) {
            vals.push(2)
          } else if (markets.every((x) => +x.status === 3)) {
            vals.push(3)
          } else if (markets.some((x) => +x.status === 0 || +x.status === 1)) {
            vals.push(0)
          } else {
            // 防止因状态不统一导致outcome已隐藏而descreption和标题还存在
            vals.push(3)
          }
        } else {
          vals.push(markets.status)
        }
      })

      const _val = Array.from(new Set(vals))

      return _val.length > 1 ? val : _val[0]
    }
  },
  watch: {
    checkIsActive: {
      immediate: true,
      handler(val) {
        clearTimeout(this._timer)
        if (val === 2) {
          this._timer = setTimeout(() => {
            this.active = false
            eventBus.$emit('update-mini-footer')
          }, 5000)
        } else if (val === 3) {
          this.active = false
        } else {
          this.active = true
        }
        eventBus.$emit('update-mini-footer')
      }
    },
    active: {
      immediate: true,
      handler(currActive) {
        this.$emit('active-change', {
          marketId: this.marketId,
          active: currActive
        })
      }
    }
  },
  created() {
    const { comboType, comboGroupName, marketGroups } = this.group
    if (comboType === 1) {
      this.id = `${comboType}_${comboGroupName}`
      this.marketInfo = this.comboMarketGroups.map[this.id][0]
    } else {
      const markets = marketGroups.filter((group) => group.markets.length)
      if (markets.length) {
        const { id } = markets[0].markets[0]
        this.id = `${comboType}_${comboGroupName}_${id}`
        const groups = this.comboMarketGroups.map[this.id]
        if (Array.isArray(groups)) {
          this.marketInfo = groups[0]
        } else {
          this.marketInfo = groups
        }
      }
    }
  },
  mounted() {
    // 此处暂时取巧，为了能获取初始为display: none的outcome宽度，计算conflict loading时间，从而避免多层props传递
    // TODO: test if this is still needed
    // if (!this.shouldExpand) {
    //   this.marketContent.style = { height: 0 }
    //   this.$emit('toggle-expand', {
    //     marketId: this.group.comboGroupName
    //   })
    //   this.timer = setTimeout(() => {
    //     this.$emit('toggle-expand', {
    //       marketId: this.group.comboGroupName
    //     })
    //     clearTimeout(this.timer)
    //   }, 10)
    // }
  },
  beforeDestroy() {
    clearTimeout(this._timer)
  },
  methods: {
    // 判断 market 中是否有 outcome 存在, 有可能新增 market 没有 outcomes
    hasOutcomes(market = {}) {
      const { outcomes } = market
      return outcomes && outcomes.order && outcomes.order.length
    },
    handleExpand() {
      this.$emit('toggle-expand', {
        marketId: this.marketId
      })
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.m-combo-market-item {
  padding: 10px;

  &--header {
    height: 44/@rem;
    line-height: 44/@rem;
  }

  &--name {
    color: #fff;
    font-size: 12/@rem;
    line-height: 16/@rem;
  }

  &--content {
    padding: 0 0 6/@rem;
  }

  .m-collapse-btn {
    display: inline-block;
    width: 16/@rem;
    height: 16/@rem;
    line-height: 16/@rem;
    text-align: center;

    .m-icon-trangle {
      .m-icon-trangle(5/@rem; #666);

      transition: transform 0.2s linear;

      &.active {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .m-combo-market-item {
  background: #fff;

  .m-market-item--name {
    color: #000;
  }

  .m-icon-trangle.down::before {
    border-top-color: #999;
  }

  &:last-child {
    border-bottom: none
  }

  ::v-deep .combo-market-select {
    .select-box dl {
      border: none;
      background: #fff;
      filter: drop-shadow(0 0 10px rgba(0, 0, 0, 20%));

      &::before {
        border-color: #fff;
        background: #fff;
      }

      span {
        border-bottom: 1px solid #ededed;
        color: #000;

        &.active {
          color: #b2621b;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
